import { Injectable } from "@angular/core";
import { SectionItem } from "projects/phdsoft/common/src/lib/models/sectionitem-info.model";
import { AbstractCacheService } from "src/app/shared/services/abstract-cache.service";

@Injectable({
    providedIn: 'root'
  })
  export class SectionsCacheService extends AbstractCacheService<SectionItem[]> {

  }
